import api from "@/config/api";
import { CategoryView } from "@/types/report";
import { Params } from "@/types/utils";
import { log } from "@/utils/logger";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

const useQueryCategory = () => {
    const { oid, sid, rid } = useParams<Params>();
    const enabled = !!(oid && sid && rid);

    const getCategoriesOverview = async () => {
        try {
            const data = await api.get<{ incomings: CategoryView[]; outgoings: CategoryView[] }>(
                `/organizations/${oid}/submissions/${sid}/reports/${rid}/categories-overview`,
            );

            return data;
        } catch (e) {
            log.error(e);
        }
    };

    return useQuery({
        queryKey: ["categories-overview", oid, sid, rid],
        queryFn: getCategoriesOverview,
        enabled,
    });
};

export { useQueryCategory };
